module.exports = __webpack_public_path__ + "static/9b75c122066610cb0f735e69d42dd4b8a66347c44f67420687156553e566d6f2-6d3b13a2fa674e8782c3745d230dcf3d.jpeg";